if (!customElements.get('wh-gallery-navigation')) {
  customElements.define('wh-gallery-navigation', class extends HTMLElement {
    async connectedCallback() {
      await customElements.whenDefined('media-gallery');
      if (!this.isConnected) return;
      this.gallery = this.closest('media-gallery');
      this.viewer = this.gallery?.querySelector('[id^="GalleryViewer-"]');
      this.list = this.viewer?.querySelector('.product__media-list');
      if (!this.list) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.previous = this.querySelector('[data-direction="-1"]');
      this.next = this.querySelector('[data-direction="1"]');
      this.querySelectorAll('[data-direction]').forEach((button) => {
        button.addEventListener('click', () => this.move(Number(button.dataset.direction)), { signal });
      });
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, { signal });
      this.list.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary || event.button !== 0) return;
        this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
      }, { signal });
      this.list.addEventListener('pointermove', (event) => {
        const gesture = this.gesture;
        if (!gesture || gesture.id !== event.pointerId) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) * 1.3) {
          this.list.setPointerCapture(event.pointerId);
        }
      }, { signal });
      this.list.addEventListener('pointerup', (event) => {
        const gesture = this.gesture;
        this.gesture = null;
        if (!gesture || gesture.id !== event.pointerId) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        const threshold = Math.min(80, Math.max(40, this.list.clientWidth * .12));
        if (Math.abs(dx) >= threshold && Math.abs(dx) > Math.abs(dy) * 1.3) {
          this.blockClickUntil = performance.now() + 400;
          event.preventDefault();
          this.move(dx < 0 ? 1 : -1);
        }
        if (this.list.hasPointerCapture(event.pointerId)) this.list.releasePointerCapture(event.pointerId);
      }, { signal });
      this.list.addEventListener('pointercancel', () => { this.gesture = null; }, { signal });
      this.list.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
      this.list.addEventListener('click', (event) => {
        if (event.detail && performance.now() < this.blockClickUntil) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { signal, capture: true });
      this.viewer.addEventListener('slideChanged', (event) => {
        const id = event.detail?.currentElement?.dataset.mediaId;
        if (id) this.sync(id);
      }, { signal });
      this.observer = new MutationObserver((records) => {
        if (records.some((record) => record.target === this.list || record.target.matches?.('.product__media-item'))) this.sync();
      });
      this.observer.observe(this.list, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] });
      this.sync();
    }

    sync(mediaId) {
      this.slides = Array.from(this.list.querySelectorAll('.product__media-item[data-media-id]'))
        .filter((slide) => !slide.hidden && !slide.classList.contains('hidden'));
      this.hidden = this.slides.length < 2;
      const active = mediaId || this.slides.find((slide) => slide.classList.contains('is-active'))?.dataset.mediaId;
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.dataset.mediaId === active));
      this.previous.disabled = this.slides.length < 2;
      this.next.disabled = this.slides.length < 2;
    }

    move(direction) {
      if (this.slides.length < 2) return;
      const target = this.slides[(this.index + direction + this.slides.length) % this.slides.length];
      if (!target) return;
      this.gallery.setActiveMedia(target.dataset.mediaId, false);
      this.sync(target.dataset.mediaId);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}
